/**
 * Get API Base URL - intelligent defaults based on hostname
 */
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  const hostname = window.location.hostname;
  if (hostname.includes('sccnhub.com')) {
    return 'https://api.sccnhub.com';
  }
  return 'http://localhost:5000';
};

/**
 * Get image source URL - handles both base64 and file URLs
 * @param {string} imageData - Either base64 string, file path, or URL
 * @returns {string} - Proper image src value
 */
export const getImageSrc = (imageData) => {
  if (!imageData || imageData === '') return '';
  
  // Ensure it's a string
  imageData = String(imageData).trim();
  
  // If it's already a full URL (http:// or https://), use it as-is
  if (imageData.startsWith('http://') || imageData.startsWith('https://')) {
    return imageData;
  }
  
  // If it's already a data URI, use it as-is
  if (imageData.startsWith('data:')) {
    return imageData;
  }

  // Detect raw base64 by known signatures BEFORE the relative-path check,
  // because JPEG base64 starts with "/9j/" which also starts with "/".
  if (imageData.length > 100) {
    let mimeType = null;
    if (imageData.startsWith('UklGR')) {
      mimeType = 'image/webp';
    } else if (imageData.startsWith('iVBORw')) {
      mimeType = 'image/png';
    } else if (imageData.startsWith('R0lGOD')) {
      mimeType = 'image/gif';
    } else if (imageData.startsWith('/9j/')) {
      mimeType = 'image/jpeg';
    }
    if (mimeType) {
      return `data:${mimeType};base64,${imageData}`;
    }
  }

  // If it's a relative path (starts with /), prepend the API base URL
  if (imageData.startsWith('/')) {
    const apiBaseUrl = getApiBaseUrl();
    return `${apiBaseUrl}${imageData}`;
  }
  
  // Fallback - return as-is (might be a reference we don't understand)
  return imageData;
};

/**
 * Get the full URL for an uploaded file path
 * Alias for getImageSrc for consistency with admin side
 */
export const getUploadUrl = getImageSrc;
